import type { CaseGetFilterDto, CaseResponseDto } from '@bandido/shared/dtos';

export function bookingCaseSearchFilters(
  agencyId: string | number,
  search: string,
): CaseGetFilterDto {
  return {
    currentPage: 1,
    pageSize: 20,
    search,
    agencies: [String(agencyId)],
    hasClient: true,
  };
}

/** Defensa de UI: el backend filtra antes de paginar y este borde no mezcla agencias. */
export function eligibleBookingCaseOptions(
  cases: CaseResponseDto[],
  agencyId: string | number,
): CaseResponseDto[] {
  const expectedAgencyId = Number(agencyId);
  return cases.filter(
    (item) => item.agencyId === expectedAgencyId && Boolean(item.clientId),
  );
}
